import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail, Globe, Users, GraduationCap, Building2, Calendar } from "lucide-react";
import TiltCard from "../components/TiltCard";
import CollegeProfile from "../components/CollegeProfile";
import { colleges } from "../data/mock";

export default function CollegeDetail() {
  const { slug } = useParams();
  const c = colleges.find(x => x.slug === slug);
  if (!c) return (
    <div style={{ padding: 80, textAlign: "center" }}>
      <h2 className="font-serif" style={{ color: "#C2410C" }}>College not found</h2>
      <Link to="/colleges" style={{ color: "#F97316" }}>Back to Colleges</Link>
    </div>
  );

  const kpis = [
    { icon: GraduationCap, label: "MBBS Seats", value: c.seats },
    { icon: Users, label: "Students", value: c.students },
    { icon: Building2, label: "Faculty", value: c.faculty },
  ];

  return (
    <div className="page-enter">
      <section style={{ position: "relative", padding: "40px 24px 60px" }} className="soft-bg" data-testid="college-detail">
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <Link to="/colleges" style={{ color: "#C2410C", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, marginBottom: 22 }}>
            <ArrowLeft size={14} /> Back to All Colleges
          </Link>
          <TiltCard intensity={3}>
            <div style={{ height: 340, overflow: "hidden", borderTopLeftRadius: 20, borderTopRightRadius: 20, position: "relative" }}>
              <img src={c.img} alt={c.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, transparent 35%, rgba(124,45,18,0.9) 100%)" }} />
              <div style={{ position: "absolute", bottom: 20, left: 30, color: "#FFFFFF" }}>
                <span className="badge badge-yellow">{c.district}</span>
                <h1 className="font-serif" style={{ fontSize: "2.4rem", marginTop: 10, fontWeight: 800 }}>{c.name}</h1>
                <div style={{ display: "flex", gap: 16, marginTop: 8, fontSize: 13, color: "rgba(255,255,255,0.85)" }}>
                  <span><Calendar size={12} style={{ verticalAlign: "middle" }} /> Established {c.established}</span>
                </div>
              </div>
            </div>

            <div style={{ padding: 30 }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 16 }}>
                {kpis.map(k => (
                  <div key={k.label} style={{ padding: 18, borderRadius: 14, background: "linear-gradient(180deg,#ffffff,#FFF7ED)", border: "1px solid rgba(194,65,12,0.08)", textAlign: "center" }}>
                    <div className="icon-tile" style={{ display: "inline-flex", width: 40, height: 40, borderRadius: 10, marginBottom: 8 }}>
                      <k.icon size={16} />
                    </div>
                    <div style={{ fontSize: 26, fontWeight: 800, color: "#C2410C" }}>{k.value}</div>
                    <div style={{ fontSize: 11, color: "#78716C", letterSpacing: 0.5 }}>{k.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ marginTop: 30, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 14 }}>
                <a href={`tel:${c.phone}`} style={{ textDecoration: "none" }}>
                  <div className="premium-card" style={{ padding: 16, display: "flex", alignItems: "center", gap: 12 }}>
                    <Phone size={18} color="#EA580C" />
                    <div>
                      <div style={{ fontSize: 11, color: "#78716C", fontWeight: 600 }}>PHONE</div>
                      <div style={{ fontSize: 13, color: "#1C1917", fontWeight: 600 }}>{c.phone}</div>
                    </div>
                  </div>
                </a>
                <a href={`mailto:${c.email}`} style={{ textDecoration: "none" }}>
                  <div className="premium-card" style={{ padding: 16, display: "flex", alignItems: "center", gap: 12 }}>
                    <Mail size={18} color="#EA580C" />
                    <div>
                      <div style={{ fontSize: 11, color: "#78716C", fontWeight: 600 }}>EMAIL</div>
                      <div style={{ fontSize: 13, color: "#1C1917", fontWeight: 600 }}>{c.email}</div>
                    </div>
                  </div>
                </a>
                <a href={c.website} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                  <div className="premium-card" style={{ padding: 16, display: "flex", alignItems: "center", gap: 12 }}>
                    <Globe size={18} color="#EA580C" />
                    <div>
                      <div style={{ fontSize: 11, color: "#78716C", fontWeight: 600 }}>OFFICIAL WEBSITE</div>
                      <div style={{ fontSize: 13, color: "#1C1917", fontWeight: 600 }}>Visit portal</div>
                    </div>
                  </div>
                </a>
              </div>

              <div style={{ display: "flex", gap: 12, marginTop: 28, flexWrap: "wrap" }}>
                <a href={c.registerLink} target="_blank" rel="noreferrer" className="btn-primary-3d" data-testid="college-register-btn" style={{ textDecoration: "none" }}>Register Online</a>
                <a href={c.payLink} target="_blank" rel="noreferrer" className="btn-red" data-testid="college-pay-btn" style={{ borderRadius: 999, textDecoration: "none" }}>Pay Fee</a>
              </div>
            </div>
          </TiltCard>
        </div>
      </section>

      <CollegeProfile slug={slug} college={c} />
    </div>
  );
}
